<template>
  <div class="novidades-portal__timeline">
    <div
      v-for="item in items"
      :key="item.idnovidade"
      class="novidades-portal__timeline-item"
    >
      <div
        class="novidades-portal__timeline-node"
        :class="{
          'novidades-portal__timeline-node--latest': isRecent(item)
        }"
        :style="nodeStyle(item)"
      >
        <v-icon x-small color="white">{{ iconClass(item) }}</v-icon>
      </div>

      <div
        class="novidades-portal__release-card"
        @click="onSelect(item.idnovidade)"
      >
        <div class="novidades-portal__card-top">
          <div>
            <span
              class="novidades-portal__color-badge novidades-portal__color-badge--dot-only"
              :style="badgeStyle(item)"
              :title="scheme(item).name"
              :aria-label="`Cor do release: ${scheme(item).name}`"
            >
              <span
                class="novidades-portal__dot"
                :style="{ backgroundColor: scheme(item).dotColor }"
              />
            </span>
            <span
              v-if="isRecent(item)"
              class="novidades-portal__latest-badge ml-2"
            >
              ★ Mais recente
            </span>
          </div>
          <div class="novidades-portal__card-dates">
            <span>
              <v-icon x-small class="mr-1">far fa-calendar-alt</v-icon>
              {{ formatDate(item).date }}
            </span>
            <span>·</span>
            <span>
              <v-icon x-small class="mr-1">far fa-clock</v-icon>
              {{ formatDate(item).time }}
            </span>
          </div>
        </div>

        <h2 class="novidades-portal__card-title">{{ item.descricao }}</h2>
        <p v-if="item.resumo" class="novidades-portal__card-resumo">
          {{ item.resumo }}
        </p>

        <div
          v-if="improvements(item).length"
          class="novidades-portal__highlights"
        >
          <div class="novidades-portal__highlights-label">
            Destaques desta atualização ({{ improvements(item).length }} itens):
          </div>
          <div class="novidades-portal__highlights-grid">
            <div
              v-for="imp in improvements(item).slice(0, 4)"
              :key="imp.id"
              class="novidades-portal__highlight-item"
            >
              <span>{{ imp.emoji || "✨" }}</span>
              <div class="min-width-0">
                <div class="novidades-portal__highlight-title">
                  {{ imp.title }}
                </div>
                <div class="novidades-portal__highlight-desc">
                  {{ imp.description }}
                </div>
              </div>
            </div>
          </div>
          <p
            v-if="improvements(item).length > 4"
            class="novidades-portal__text-soft mt-2 mb-0"
            style="font-size: 11px;"
          >
            + {{ improvements(item).length - 4 }} outras melhorias neste boletim
          </p>
        </div>

        <div class="novidades-portal__card-footer">
          <div class="d-flex flex-wrap" style="gap: 6px;">
            <span
              v-for="tag in (item.palavras_chave || []).slice(0, 5)"
              :key="tag"
              class="novidades-portal__tag-pill"
            >
              #{{ tag }}
            </span>
            <span
              v-if="(item.palavras_chave || []).length > 5"
              class="novidades-portal__tag-pill"
            >
              +{{ item.palavras_chave.length - 5 }}
            </span>
          </div>
          <div class="d-flex align-center">
            <button
              type="button"
              class="novidades-portal__copy-btn"
              title="Copiar link"
              @click.stop="copyLink(item.idnovidade)"
            >
              <v-icon small>
                {{
                  copiedId === item.idnovidade ? "fas fa-check" : "far fa-copy"
                }}
              </v-icon>
            </button>
            <span class="novidades-portal__cta ml-2">
              Ver detalhes e melhorias
              <v-icon x-small>fas fa-arrow-right</v-icon>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getColorScheme,
  formatDateTimeBR,
  parseImprovementsFromContent,
  resolveNovidadeIcon
} from "@/utils/novidades";

export default {
  name: "NovidadesTimelineView",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    recentIds: {
      type: Array,
      default: () => []
    },
    isDark: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    copiedId: null,
    copyTimer: null
  }),
  beforeDestroy() {
    if (this.copyTimer) clearTimeout(this.copyTimer);
  },
  methods: {
    scheme(item) {
      return getColorScheme(item.cor, { isDark: this.isDark });
    },
    badgeStyle(item) {
      const s = this.scheme(item);
      return {
        backgroundColor: s.badgeBg,
        color: s.badgeText,
        borderColor: s.badgeBorder
      };
    },
    nodeStyle(item) {
      const s = this.scheme(item);
      return { backgroundColor: s.nodeBg };
    },
    iconClass(item) {
      return resolveNovidadeIcon(item.icone).class;
    },
    formatDate(item) {
      return formatDateTimeBR(item.data_publicacao);
    },
    improvements(item) {
      return parseImprovementsFromContent(item.conteudo || "", {
        tags: item.palavras_chave || []
      });
    },
    isRecent(item) {
      return this.recentIds.includes(item.idnovidade);
    },
    onSelect(idnovidade) {
      this.$emit("select", idnovidade);
    },
    copyLink(idnovidade) {
      const url = `${window.location.origin}${window.location.pathname}?idnovidade=${idnovidade}`;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          this.copiedId = idnovidade;
          if (this.copyTimer) clearTimeout(this.copyTimer);
          this.copyTimer = setTimeout(() => {
            this.copiedId = null;
          }, 2000);
        });
      }
    }
  }
};
</script>

<style scoped>
.min-width-0 {
  min-width: 0;
}
.novidades-portal__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}
</style>
